import { render, staticRenderFns } from "./ProformaInvoice.vue?vue&type=template&id=d8b36960&"
import script from "./ProformaInvoice.vue?vue&type=script&lang=js&"
export * from "./ProformaInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports